import { createSlice } from "@reduxjs/toolkit";
import { getAdminTransactionsListThunk } from "../thunks/transactionThunk";

const initialState = {
    transactions: null,
};

const transactionSlice = createSlice({
    name: "transaction",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getAdminTransactionsListThunk.fulfilled, (state, action) => {
            state.transactions = action?.payload?.data;
        })
    }
});

export default transactionSlice.reducer;
